<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />

    <div v-if="!this.$store.getters.isLoading" class="flex xs12">
      <va-card :title="$t('appConfig.actionNotifications')">
        <template slot="actions">
          <va-button icon="fa fa-plus" @click="createModal" v-if="appConfigurations.length <= 2"></va-button>
        </template>
        <div class="va-card__body" v-if="appConfigurations.length < 1">
          <va-notification v-if="appConfigurations.length < 1" color="info">
            <va-badge color="info">
              {{ $t('badges.info') }}
            </va-badge>
            {{ $t('appConfig.noConfigFound') }}
          </va-notification>
        </div>
      </va-card>
    </div>

    <div v-if="!this.$store.getters.isLoading && appConfigurations.length > 0" class="flex xs12">
      <div class="cards-container row d-flex wrap align--start actions-cards">
        <div class="flex xs12 sm6 lg4 xl4" v-for="configuration in appConfigurations" v-bind:key="configuration.appConfigurationId">
          <va-card>
            <div class="va-card__header">
              <div class="va-card__header-title" style="color: rgb(108, 127, 238);">{{ configuration.appConfigurationAction.description }}
                <span v-if="configuration.appConfigurationMessage.isIncludeUrl" :title="$t('appConfig.addUrl')"><i class="va-icon fa fa-link"></i></span></div>
              <div class="va-card__header-actions">
                <KebabMenu>
                  <div slot="buttons">
                    <va-button-group>
                      <!--<va-button flat small color="gray" @click="onUpdate(configuration)" icon-right="fa fa-pencil"> {{ $t('kebabMenu.update') }}</va-button>-->
                      <va-button flat small color="gray" :disabled="disabledDelete" @click="showPromptModal(configuration)" icon-right="fa fa-trash"> {{ $t('kebabMenu.remove') }}</va-button>
                    </va-button-group>
                  </div>
                </KebabMenu>
              </div>
            </div>
            <p>{{ $t('appConfig.type') }}: <span>{{ configuration.appConfigurationType.description }}</span></p>
            <p v-if="configuration.locations && configuration.locations.length">{{ $t('appConfig.locations') }}:
              <span class="location" v-for="(locationId, index) in configuration.locations" :key="index" @click="toLocation(locationId)">
                {{ locationNames(configuration)[index] }}
                {{ index !== configuration.locations.length - 1 ? ', ' : '' }}
              </span>
            </p>
            <p class="message">{{ $t('appConfig.message') }}: <VueInlineTextEditor :value="configuration.appConfigurationMessage.message" @change="onChange" @update="onUpdate(configuration)"/></p>
          </va-card>
        </div>
      </div>
    </div>

    <va-modal
      v-model="openCreateModal"
      :title="$t('appConfig.createModal.title')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <SwappingSquaresSpinner v-if="modalLoader"
        :animation-duration="1000"
        :size="90"
        :color="this.$store.getters.config.palette.primary"
        style="margin: 30px auto;"
      />
      <form v-if="!modalLoader" @submit.prevent="onsubmit()">
        <div class="row">
          <div class="flex md12 xs12">
            <va-select
              :label="$t('appConfig.createModal.selectType')"
              v-model="configurationType"
              keyBy="appConfigurationTypeId"
              textBy="description"
              :options="appConfigurationTypes"
              :error="!!configurationTypeErrors.length"
            />
          </div>
          <div class="flex md12 xs12">
            <va-select
              :label="$t('appConfig.createModal.selectAction')"
              v-model="configurationAction"
              keyBy="appConfigurationActionId"
              textBy="description"
              :options="appConfigurationActions"
              :error="!!configurationActionErrors.length"
            />
          </div>
          <va-input
            v-model="messageAction.message"
            type="text-area"
            :label="$t('appConfig.createModal.message')"
            class="flex xs12"
            :error="!!configurationMessageErrors.length"
            :error-messages="configurationMessageErrors"
          />
          <fieldset>
            <va-checkbox
              :label="$t('appConfig.createModal.includeAppUrl')"
              v-model="messageAction.includeUrl"
            />
          </fieldset>
          <fieldset>
            <va-checkbox
              :label="$t('appConfig.createModal.isGlobal')"
              v-model="isGlobal"
            />
          </fieldset>
          <div class="flex md12 xs12">
            <va-select
              :disabled="locations.length < 1 || isGlobal"
              :label="isGlobal ? $t('appConfig.createModal.selectLocations') : $t('appConfig.createModal.selectLocationsRequired')"
              v-model="selectedLocations"
              :placeholder="locations.length < 1 ? $t('appConfig.createModal.noLocation') : $t('appConfig.createModal.multipleLocationSelect')"
              multiple
              searchable
              textBy="name"
              keyBy="eventId"
              :options="locations"
              :error="!!locationErrors.length"
            />
          </div>
        </div>
        <div class="d-flex justify--center mt-3">
          <va-button color="gray" @click="disableModal()" class="my-0 ">{{ $t('appConfig.createModal.btnClose') }}</va-button>
          <va-button type="submit" class="my-0">{{ $t('appConfig.createModal.btnCreate') }}</va-button>
        </div>
        <!--        <div class="d-flex justify&#45;&#45;center mt-3">-->
        <!--          <va-button type="submit" class="my-0">Update company</va-button>-->
        <!--        </div>-->
      </form>
    </va-modal>
    <va-modal
      v-model="showRemoveModal"
      size="small"
      :title="$t('appConfig.removeModal.title')"
      :message="$t('appConfig.removeModal.message')"
      :hideDefaultActions="true"
      :noOutsideDismiss="true"
      :noEscDismiss="true"
    >
      <div class="d-flex justify--center mt-3">
        <va-button color="gray" @click="showRemoveModal=false" class="my-0 ">{{ $t('appConfig.removeModal.no') }}</va-button>
        <va-button type="submit" @click="removeConfiguration(configurationInPrompt)" class="my-0">{{ $t('appConfig.removeModal.yes') }}</va-button>
      </div>
    </va-modal>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
// import AppConfigurationTable from '../appConfiguration/AppConfigurationTable'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'
import VueInlineTextEditor from 'vue-inline-text-editor'
import KebabMenu from '@/components/menus/KebabMenu.vue'
export default {
  components: { SwappingSquaresSpinner, VueInlineTextEditor, KebabMenu },
  mixins: [errorHandlerMixin],
  name: 'AppConfiguration',
  data () {
    return {
      openCreateModal: false,
      messageAction: {
        message: '',
        includeUrl: false,
      },
      isGlobal: true,
      modalLoader: false,
      configurationType: {},
      configurationAction: {},
      appConfigurations: [],
      appConfigurationActions: [],
      appConfigurationTypes: [],
      configurationActionErrors: [],
      configurationMessageErrors: [],
      configurationTypeErrors: [],
      latestValue: '',
      disabledDelete: false,
      showRemoveModal: false,
      configurationInPrompt: null,
      locations: [],
      selectedLocations: [],
      locationErrors: [],
      locationIds: [],
    }
  },
  methods: {
    async createModal () {
      this.configurationActionErrors = []
      this.configurationMessageErrors = []
      this.configurationTypeErrors = []
      this.openCreateModal = true
    },
    async disableModal () {
      this.openCreateModal = false
      this.openCreateModal = false
      this.messageAction = {
        message: '',
        includeUrl: false,
      }
      this.configurationType = {}
      this.configurationAction = {}
    },
    async onsubmit () {
      this.configurationActionErrors = this.configurationAction ? [] : [this.$t('appConfig.validation.selectAction')]
      this.configurationMessageErrors = this.messageAction.message ? [] : [this.$t('appConfig.validation.messageRequired')]
      this.configurationTypeErrors = this.configurationType ? [] : [this.$t('appConfig.validation.selectType')]
      if (!this.isGlobal) {
        this.locationErrors = this.selectedLocations.length ? [] : [this.$t('appConfig.validation.selectLocation')]
      }
      this.selectedLocations.forEach(item => {
        this.locationIds.push(item.eventId)
      })
      if (!this.formConfigurationReady) {
        return
      }
      this.modalLoader = true
      await this.$store.dispatch('createAppConfiguration', {
        appConfigurationActionId: this.configurationAction.appConfigurationActionId,
        appConfigurationMessage: {
          message: this.messageAction.message,
          isIncludeUrl: this.messageAction.includeUrl,
        },
        appConfigurationTypeId: this.configurationType.appConfigurationTypeId,
        isGlobal: this.isGlobal,
        locations: this.locationIds,
      })
        .then((resp) => this.addNewConfigurations(resp.data.message))
        .then(() => this.disableModal()).then(() => { this.modalLoader = false })
        .catch(error => {
          this.errorHandler(error.response)
          this.modalLoader = false
        })
    },
    async addNewConfigurations (configuration) {
      this.appConfigurations.splice(this.appConfigurations.length, -1, configuration)
    },
    async initAppConfigurations () {
      this.appConfigurations.splice(0, this.appConfigurations.length, ...this.$store.getters.appConfigurations)
      this.appConfigurationActions.splice(0, this.appConfigurationActions.length, ...this.$store.getters.appConfigurationActions)
      this.appConfigurationTypes.splice(0, this.appConfigurationTypes.length, ...this.$store.getters.appConfigurationTypes)
      this.$store.commit('setLoading', false)
    },
    onChange: function (e) {
      this.latestValue = e.srcElement.value
    },
    async onUpdate (configuration) {
      await this.updateConfigurations(configuration)
    },
    async updateConfigurations (configuration) {
      const theConfig = configuration
      const conf = this.appConfigurations.find((item) => {
        return (item.appConfigurationId === theConfig.appConfigurationId)
      })
      if (!conf) {
        return
      }
      await this.$store.dispatch('updateAppConfiguration', {
        message: this.latestValue,
        appConfigurationId: conf.appConfigurationId,
      }).catch((error) => this.errorHandler(error.response))
    },
    async removeConfiguration (configuration) {
      this.disabledDelete = true
      await this.$store.dispatch('deleteAppConfiguration', configuration.appConfigurationId)
        .then(() => {
          this.removeFromArray(configuration)
          this.showRemoveModal = false
        }).catch(error => {
          this.errorHandler(error.response)
          this.showRemoveModal = false
        })
    },
    async removeFromArray (configuration) {
      const conf = this.appConfigurations.findIndex((item) => {
        return (item.appConfigurationId === configuration.appConfigurationId)
      })
      this.appConfigurations.splice(conf, 1)
      this.disabledDelete = false
    },
    showPromptModal (configuration) {
      this.configurationInPrompt = configuration
      this.showRemoveModal = true
    },
    // getStatusColor (status) {
    //   if (status) {
    //     return 'success'
    //   }
    //   return 'danger'
    // },
    async getTheLocations () {
      await this.$store.dispatch('getLocations')
        .then(resp => {
          this.initLocations()
        })
        .catch(error => {
          this.errorHandler(error.response)
          this.loadingHandle = false
        })
    },
    async initLocations () {
      this.locations.splice(0, this.locations.length, ...this.$store.getters.locations)
    },
    locationNames (configuration) {
      return configuration.locations.map(locationId => {
        const location = this.locations.find(loc => loc.eventId === locationId)
        return location ? location.name : ''
      })
    },
    async toLocation (locationId) {
      await this.$router.push({
        name: 'location',
        params: { locationId: locationId },
      })
    },
  },
  computed: {
    formConfigurationReady () {
      return !(this.configurationActionErrors.length || this.configurationTypeErrors.length || this.configurationMessageErrors.length)
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getAppConfigurations')
      .then(() => this.$store.dispatch('getAppConfigurationsActions'))
      .then(() => this.$store.dispatch('getAppConfigurationsTypes'))
      .then(() => this.initAppConfigurations())
      .catch(error => {
        this.errorHandler(error.response)
        this.modalLoader = false
      })
    this.getTheLocations()
  },
}
</script>

<style lang="scss" scoped>
  .actions-cards {
    .va-card {
      &__header {
        display: flex;
        align-items: center;

        &-title {
          font-size: 1rem;
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }

          .va-icon {
            margin: 0 5px;
          }
        }

        &-actions {
          display: flex;
        }
      }

      &__body {
        overflow: visible;

        .va-button--small.va-button--with-right-icon {
          padding-right: 0.75rem;
        }

        p {
          font-size: 14px;
        }

        .location {
          color: rgb(113, 186, 255);

          &:hover {
            cursor: pointer;
          }
        }

        .message {
          display: flex;

          .inline-editor {
            margin-left: 5px;
            overflow: hidden;

            .value-display {
              white-space: inherit;
            }
          }
        }

        .add-url {
          display: flex;
          align-items: center;

          .va-badge {
            margin-left: 5px;
          }
        }
      }
    }
  }

  fieldset {
    width: 100%;
  }
</style>
